import { Component, Input, ViewChild, ElementRef, ChangeDetectionStrategy, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { UnipassData, CargCsclPrgsInfoQryVo, CargCsclPrgsInfoDtlQryVo, AiUser, UnipassCntrList, CntrQryBrkdQryVo, EtprRprtQryBrkdQryVo, EnterPortInfo, ShedInfo, CustInfo, LcaBrkdQryRsltVo, ShedInfo2, ShedAddress2, ShedInfoDetail } from '../../../../services/index';
import { UnipassService } from '../../../../services/index';

import * as _ from 'lodash';
import * as xmljs from 'xml-js';
import { trigger, state, style, animate, transition } from '@angular/animations';

declare var moment:any;

@Component({
  selector: 'unipass-finder-tracking',
  templateUrl: 'unipass-finder-tracking.html',
  animations: [
    trigger('collapseChange', [
        state('true',
            style({ height: '*' })
        ),
        state('false' ,
            style({ height: '0', overflow : 'hidden' }),
        ),
        transition('* => *', animate('.2s ease-out'))
      ]),
      trigger('iconChange', [
          state('false',
              style({ transform: 'rotate( 0deg )' })
          ),
          state('true',
              style({ transform: 'rotate( -180deg )' })
          ),
          transition('* => *', animate('.2s'))
      ])
  ],
})
export class ConsultDetailUnipassFinderComponent {
  @Input() showUnipass:boolean;
  @Input('shipmentBlNo') set shipmentBlNo(blno) {
    if(blno && this.showUnipass) {
      this.blNo = blno;
      var value = this.getCookie('ai_user');
      this.aiUserInfo.aiUser = value ? value : null; 

      this.init = false;
      this.loading = false;
      this.postBlNo();
    }
  }

  @Output() showShedInfoEmit:EventEmitter<boolean> = new EventEmitter();
  @Output() shedInfoEmit: EventEmitter<ShedAddress2[]> = new EventEmitter();
  @Output() showUnipassDetailEmit:EventEmitter<boolean> = new EventEmitter();
  
  @Input() showUnipassDetailFromTracking:boolean;

  blTp:string = '0';
  selectedTp:string = '0';
  blNo:string = null;
  cargMtNo:string = '';
  mblNo: string = '';
  hblNo: string = '';
  secondBlNo:string = null;
  date:string;
  selectedDate:string;
  xmlData: UnipassData = new UnipassData();
  cargInfo: CargCsclPrgsInfoQryVo= null;
  cargInfoList: CargCsclPrgsInfoQryVo[]= null;
  processInfo: Array<any> = null;
  linkUrl: string = '';

  aiUserInfo: AiUser = new AiUser();

  loading:boolean = false;
  reTryCnt:number = 0;

  cntrList: Array<any> = [];
  enterPortInfo: EtprRprtQryBrkdQryVo = new EtprRprtQryBrkdQryVo();
  shedInfo:ShedAddress2[] = [];
  custInfo: LcaBrkdQryRsltVo = new LcaBrkdQryRsltVo();

  showCntrList:boolean = false;
  showCustoms:boolean = false;
  showShedInfo:boolean = false;
  showEnterPort: boolean = false;

  cntrNo:string = '';
  enterPortCntrNo:string = '';
  dclrNo:string = '';
  shedNo:string = '';

  p: number = 1;

  showShare:boolean = false;

  copied: boolean = false;

  init:boolean = true;

  resultTorF: boolean = false;
  showUnipassDetail:boolean = false;
  cargoOpen:boolean = false;
  selectedCargo:CargCsclPrgsInfoQryVo = null;
  reTryCnt2: number = 0;
  
  constructor(
    private unipassService:UnipassService) {

    const today: Date = new Date();
    const year = today.getFullYear();

    this.date = String(year);
    this.selectedDate = String(year);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.showUnipassDetailFromTracking && changes.showUnipassDetailFromTracking.currentValue != null && changes.showUnipassDetailFromTracking.currentValue === false) {
      this.showUnipassDetail = false;
      this.showUnipassDetailEmit.emit(this.showUnipassDetail);
    }
  }

  getCookie(c_name) { 
    var i,x,y,ARRcookies = document.cookie.split(";");
    for (i=0;i<ARRcookies.length;i++) {
      x = ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);

      x = x.replace(/^\s+|\s+$/g,"");
      if (x == c_name) {
        return y;
      }
    }
  }

  handleOpenCargoSelectBox() {
    this.cargoOpen = !this.cargoOpen;
  }

  handleSelectCargo(value:CargCsclPrgsInfoQryVo, event: Event) {
    this.cargoOpen = false;
    this.selectedCargo = value;
    this.secondBlNo = value.hblNo._text;
    this.loading = true;
    this.postCntrInfo();
    event.stopPropagation();
    event.preventDefault();
  }

  handleShowUnipass() {
    this.showUnipassDetail = !this.showUnipassDetail;
    this.showUnipassDetailEmit.emit(this.showUnipassDetail);
  }

  prcsDtmSetter(date) {
    if(date) {
      return moment(date, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss');
    }
  }
  postBlNo() {
    this.loading = true;
    
    if(this.blNo) {
      this.blTp = this.selectedTp;
      this.date = this.selectedDate;
      this.getUnipassData();
    } else {
      this.loading = false;
    }

    this.reTryCnt = 0;

  }

  getUnipassData() {
    let blNo = this.blNo.trim().toUpperCase();
    var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;

    if(regExp.test(blNo)){
      blNo = blNo.replace(regExp, "")
    }
    
    if(this.blTp == '0') {
      this.cargMtNo = blNo;
      this.mblNo = '';
      this.hblNo = '';
    } else if(this.blTp == '1') {
      this.cargMtNo = '';
      this.mblNo = blNo;
      this.hblNo = '';
    } else if(this.blTp == '2') {
      this.cargMtNo = '';
      this.mblNo = '';
      this.hblNo = blNo;
    }

    this.unipassService.postBlNoToUnipass(this.aiUserInfo.aiUser, this.cargMtNo, this.mblNo, this.hblNo, this.date).subscribe(resp => {
      if(resp.result) {
        this.makeUnipassData(resp);
        this.resultTorF = true;
      } else {
        this.resultTorF = false;  
      }
      this.loading = false; 
    },
    err => {
      this.resultTorF = false;
      this.loading = false;
      },
      () => {
        this.loading = false;
      }
    )
  }

  makeUnipassData(resp) {
    let xmlData = JSON.parse(xmljs.xml2json(resp.data, {compact: true, spaces: 4, ignoreDeclaration: true})) as any as UnipassData;
    this.xmlData = xmlData;

    const today: Date = new Date();
    const year: number = today.getFullYear();

    if(this.xmlData.cargCsclPrgsInfoQryRtnVo.tCnt._text == '-1' || this.xmlData.cargCsclPrgsInfoQryRtnVo.tCnt._text == '0') { //ntceInfo
      if(this.reTryCnt < 12) {
        if(this.reTryCnt === 0) {
          this.blTp = '1'
          this.date = String(year);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 1) {
          this.blTp = '2';
          this.date = String(year);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 2) {
          this.blTp = '0';
          this.date = String(year);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 3) {
          this.blTp = '1';
          this.date = String(year - 1);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 4) {
          this.blTp = '2';
          this.date = String(year - 1);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 5) {
          this.blTp = '0';
          this.date = String(year - 1);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 6) {
          this.blTp = '1';
          this.date = String(year - 2);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 7) {
          this.blTp = '2';
          this.date = String(year - 2);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 8) {
          this.blTp = '0';
          this.date = String(year - 2);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 9) {
          this.blTp = '1';
          this.date = String(year - 3);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 10) {
          this.blTp = '2';
          this.date = String(year - 3);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        } else if(this.reTryCnt === 11) {
          this.blTp = '0';
          this.date = String(year - 3);
          this.reTryCnt++;
          this.getUnipassData();
          return;
        }
      } else {
        // this.alertService.alert({
        //   alertType: AlertType.WARNING,
        //   message: '검색결과가 없습니다.',
        //     okTxt: '확인'});
        this.reTryCnt = 0;
        this.cargInfo = null;
        this.processInfo = null;
        this.cargInfoList = null;
        return;
      }       
    } else {
      this.selectedTp = this.blTp;
      this.selectedDate = this.date;
      this.linkUrl = 'https://www.tradlinx.com/unipass?type=' + this.selectedTp + '&blNo=' + this.blNo + '&blYr=' + this.selectedDate;
    }

    if(this.xmlData.cargCsclPrgsInfoQryRtnVo && this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoQryVo) {
      if(_.isArray(this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoQryVo)) {
        this.cargInfoList = this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoQryVo;
        this.selectedCargo = this.cargInfoList[0];
        if(this.selectedCargo) {
          this.postCntrInfo();
        }
        this.cargInfo = null;
      } else {
        this.cargInfo = this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoQryVo;
        this.selectedCargo = null;
        this.cargInfoList = null;
      }
    } else {
      this.cargInfoList = null;
      this.cargInfo = null;
      this.selectedCargo = null;
    }

    if(this.xmlData.cargCsclPrgsInfoQryRtnVo && this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoDtlQryVo) {
      let processInfo = this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoDtlQryVo;
      if(!_.isArray(processInfo)) {
        this.processInfo = [];
        //@ts-ignore;
        this.processInfo.push(processInfo);
      } else {
        this.processInfo = processInfo;
      }

      this.processInfo.map(process => {
        if(process.dclrNo._text && process.rlbrBssNo._text && _.includes(process.rlbrBssNo._text, '관세')) process.hasCustom = true;
        else return process.hasCustom = false;
      });
    } else {
      this.processInfo = null;
    }

    this.reTryCnt = 0;
  }

  postCntrInfo() {
    const today: Date = new Date();
    const year = today.getFullYear();

    this.blTp = '2';
    this.loading = true;
    this.date = this.selectedCargo.etprDt._text.substring(0,4) || String(year);
    this.getCntrData();
  }

  getCntrData() {
    let blNo = this.selectedCargo.hblNo._text.trim().toUpperCase();
    this.secondBlNo = blNo;
    var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;

    if(regExp.test(blNo)){
      blNo = blNo.replace(regExp, "")
    }
    
    this.cargMtNo = '';
    this.mblNo = '';
    this.hblNo = blNo;

    this.unipassService.postBlNoToUnipass(this.aiUserInfo.aiUser, this.cargMtNo, this.mblNo, this.hblNo, this.date).subscribe(resp => {
      if(resp && resp.result) {
        this.makeCntrData(resp);
        this.resultTorF = true;
      } else {
        this.resultTorF = false;  
      }
    });
    this.loading = false;
    this.showUnipassDetail = true;
    this.showUnipassDetailEmit.emit(this.showUnipassDetail);
  }

  makeCntrData(resp) {
    let xmlData = JSON.parse(xmljs.xml2json(resp.data, {compact: true, spaces: 4, ignoreDeclaration: true})) as any as UnipassData;
    this.xmlData = xmlData;

    const today: Date = new Date();
    const year: number = today.getFullYear();

    if(this.xmlData.cargCsclPrgsInfoQryRtnVo.tCnt._text == '-1' || this.xmlData.cargCsclPrgsInfoQryRtnVo.tCnt._text == '0') { //ntceInfo
      if(this.reTryCnt2 < 3) {
        if(this.reTryCnt2 === 0) {
          this.date = String(year);
          this.reTryCnt2++;
          this.getCntrData();
          return;
        } else if(this.reTryCnt2 === 1) {
          this.date = String(year - 1);
          this.reTryCnt2++;
          this.getCntrData();
          return;
        } else if(this.reTryCnt2 === 2) {
          this.date = String(year - 2);
          this.reTryCnt2++;
          this.getCntrData();
          return;
        }
      } else {
        this.reTryCnt2 = 0;
        this.processInfo = null;
        return;
      }       
    } else {
      this.selectedTp = this.blTp;
      this.selectedDate = this.date;
      this.linkUrl = 'https://www.tradlinx.com/unipass?type=' + this.blTp + '&blNo=' + this.blNo + '&blYr=' + this.date;
    }

    if(this.xmlData.cargCsclPrgsInfoQryRtnVo && this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoQryVo) {
      if(_.isArray(this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoQryVo)) {
        this.cargInfo = null;
      } else {
        this.cargInfo = this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoQryVo;
      }
    } else {
      this.cargInfo = null;
    }

    if(this.xmlData.cargCsclPrgsInfoQryRtnVo && this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoDtlQryVo) {
      let processInfo = this.xmlData.cargCsclPrgsInfoQryRtnVo.cargCsclPrgsInfoDtlQryVo;
      if(!_.isArray(processInfo)) {
        this.processInfo = [];
        //@ts-ignore;
        this.processInfo.push(processInfo);
      } else {
        this.processInfo = processInfo;
      }

      this.processInfo.map(process => {
        if(process.dclrNo._text && process.rlbrBssNo._text && _.includes(process.rlbrBssNo._text, '관세')) process.hasCustom = true;
        else return process.hasCustom = false;
      });
    } else {
      this.processInfo = null;
    }

    this.reTryCnt2 = 0;
  }


  findCntrList() {
    if(!_.isEmpty(this.cntrList) && this.cntrNo == this.cargInfo.cargMtNo._text) {
      this.showCntrList = true;
      return;
    } else {
      this.cntrNo = this.getStringWithoutSpChar(this.cargInfo.cargMtNo._text);
    }

    this.unipassService.postCntrList(this.cntrNo).subscribe(resp => {
      let xmlData = JSON.parse(xmljs.xml2json(resp.data, {compact: true, spaces: 4, ignoreDeclaration: true})) as any;
      if(xmlData.cntrQryBrkdQryRtnVo && xmlData.cntrQryBrkdQryRtnVo.cntrQryBrkdQryVo) {
        if(_.isArray(xmlData.cntrQryBrkdQryRtnVo.cntrQryBrkdQryVo)) {
          //@ts-ignore
          this.cntrList = xmlData.cntrQryBrkdQryRtnVo.cntrQryBrkdQryVo;
        } else {
          this.cntrList = [];
          this.cntrList.push(xmlData.cntrQryBrkdQryRtnVo.cntrQryBrkdQryVo);
        }

        this.cntrList.map((cntr, index)=> {
          cntr.cntrId = index + 1;
        });

        this.showCntrList = true;
      } else {
        this.cntrList = [];
        
        // this.alertService.alert({
        //   alertType: AlertType.WARNING,
        //   message: '검색결과가 없습니다.',
        //   okTxt: '확인'});
      }
    });
  }

  findEnterPort() {
    let enterPortCntrNo = this.getStringWithoutSpChar(this.cargInfo.cargMtNo._text);
    enterPortCntrNo = enterPortCntrNo.substring(0, 11);

    if(!_.isEmpty(this.enterPortInfo) && this.enterPortCntrNo == enterPortCntrNo) {
      this.showEnterPort = true;
      return;
    } else {
      this.enterPortCntrNo = enterPortCntrNo;
    }

    this.unipassService.postEtprRprt(this.enterPortCntrNo).subscribe(resp => {
      let xmlData = JSON.parse(xmljs.xml2json(resp.data, {compact: true, spaces: 4, ignoreDeclaration: true})) as any as EnterPortInfo;
      if(xmlData.etprRprtQryBrkdQryRtnVo && xmlData.etprRprtQryBrkdQryRtnVo.etprRprtQryBrkdQryVo) {
        this.enterPortInfo = xmlData.etprRprtQryBrkdQryRtnVo.etprRprtQryBrkdQryVo;
        this.showEnterPort = true;
      } else {
        this.enterPortInfo = null;
        // this.alertService.alert({
        //   alertType: AlertType.WARNING,
        //   message: '검색결과가 없습니다.',
        //   okTxt: '확인'});
      }
    })
  }

  isClickable(process:CargCsclPrgsInfoDtlQryVo) {
    if(process.dclrNo._text && process.rlbrBssNo._text && _.includes(process.rlbrBssNo._text, '관세')) return true;
    else return false;
  }

  findCustoms(process) {
    if(!process.hasCustom) return;

    let reportNo = process.dclrNo._text;
    if(!reportNo) return;

    reportNo = reportNo.substring(0, 5);

    if(!_.isEmpty(this.custInfo) && this.dclrNo == reportNo) {
      this.showCustoms = true;
      return;
    } else {
      this.dclrNo = reportNo;
    }
    
    this.unipassService.postCustInfo(this.dclrNo).subscribe(resp => {
      let xmlData = JSON.parse(xmljs.xml2json(resp.data, {compact: true, spaces: 4, ignoreDeclaration: true})) as any as CustInfo;
      if(xmlData.lcaBrkdQryRtnVo && xmlData.lcaBrkdQryRtnVo.lcaBrkdQryRsltVo) {
        this.custInfo = xmlData.lcaBrkdQryRtnVo.lcaBrkdQryRsltVo;
        this.showCustoms = true;
      } else {
        this.custInfo = new LcaBrkdQryRsltVo();
        // this.alertService.alert({
        //   alertType: AlertType.WARNING,
        //   message: '검색결과가 없습니다.',
        //   okTxt: '확인'});
      }
      
    })
  }

  findShedInfo(shedSgn) {
    
    if(!shedSgn || !shedSgn._text) return;
    
    if(!_.isEmpty(this.shedInfo) && this.shedNo == shedSgn._text) {
      this.showShedInfo = true;
      this.showShedInfoEmit.emit(this.showShedInfo);
      this.shedInfoEmit.emit(this.shedInfo);
      return;  
    }

    this.shedNo = shedSgn._text;

    this.unipassService.postShedInfo(this.shedNo).subscribe(resp => {
      if(resp.result) {
        let xmlData = JSON.parse(xmljs.xml2json(resp.data, {compact: true, spaces: 4, ignoreDeclaration: true})) as any;
        if(xmlData.shedInfoQryRtnVo && xmlData.shedInfoQryRtnVo.shedInfoQryRsltVo) {
          if(_.isArray(xmlData.shedInfoQryRtnVo.shedInfoQryRsltVo)) {
            this.shedInfo = _.cloneDeep(xmlData.shedInfoQryRtnVo.shedInfoQryRsltVo)
          } else {
            this.shedInfo = [];
            this.shedInfo.push(xmlData.shedInfoQryRtnVo.shedInfoQryRsltVo);
          }
          this.showShedInfo = true;
          this.showShedInfoEmit.emit(this.showShedInfo);
          this.shedInfoEmit.emit(this.shedInfo);
          
        } else {
          this.shedInfo = [];
          this.shedInfoEmit.emit(this.shedInfo);
          this.showShedInfo = true;
          this.showShedInfoEmit.emit(this.showShedInfo);
        }

      } else {
        this.shedInfo = [];
        this.shedInfoEmit.emit(this.shedInfo);
        this.showShedInfo = true;
        this.showShedInfoEmit.emit(this.showShedInfo);  
      }
    });

    
  }

  getStringWithoutSpChar(text:string){
    let upperText = text.trim().toUpperCase();
    var regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/gi;

    if(regExp.test(upperText)){
      upperText = upperText.replace(regExp, "")
    }

    return upperText;
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/unipass-finder-tracking.ts